<template>
    <b-modal v-model="show" :no-close-on-esc="true" :no-close-on-backdrop="true" size="xl" >
        <div class="container-fluid pl-0 pr-0" style="min-height: 500px;">
            <div class="row">
                <div class="col-12 table-responsive">
                    <h4 class="card-title text-center"><b>{{ autoDto.makerFirmName}} {{autoDto.name}}</b></h4>
                    <h4 class="card-title text-center"><b>{{$t("auto.autoCalculationLabel")}}</b></h4>
                    <div class="card">
                      <div class="table-wrapper">
                        <table class="table">
                            <tbody>
                            <tr>
                                <td class="text-center">
                                    Ишлаб чиқарилган йили
                                </td>
                                <td class="text-center">
                                    {{ autoDto.madeYear}}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    Босиб ўтган йўли
                                </td>
                                <td class="text-center">
                                    {{ autoDto.overpassKm}} км
                                </td>
                            </tr>
                            <tr v-if="autoDto.coincidental">
                                <td class="text-center">
                                    Бохаланаётган машина тўла вазни
                                </td>
                                <td class="text-center">
                                    {{ autoDto.fullWeight}} кг
                                </td>
                            </tr>
                            <tr v-if="autoDto.coincidental">
                                <td class="text-center">
                                    Турдош машинанинг номи
                                </td>
                                <td class="text-center">
                                    {{ autoDto.coincidentalAutoDto.coincidentalName}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.coincidental">
                                <td class="text-center">
                                    Турдош машина тўла вазни
                                </td>
                                <td class="text-center">
                                    {{ autoDto.coincidentalAutoDto.fullWeight}} кг
                                </td>
                            </tr>
                            <tr v-if="autoDto.foreignCar">
                                <td class="text-center">
                                    Чегирма лимити қиймати
                                </td>
                                <td class="text-center">
                                    {{autoDto.discountLimit}} USD
                                </td>
                            </tr>
                            <tr v-if="autoDto.foreignCar">
                                <td class="text-center">
                                    НДС қиймати
                                </td>
                                <td class="text-center">
                                    {{autoDto.vat}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.foreignCar">
                                <td class="text-center">
                                    Божхона ставкаси қиймати
                                </td>
                                <td class="text-center">
                                    {{autoDto.customs}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.foreignCar">
                                <td class="text-center">
                                    Йўл харажатлари қиймати
                                </td>
                                <td class="text-center">
                                    {{autoDto.road}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.foreignCar">
                                <td class="text-center">
                                    Божхона хужжатларини расмийлаштириш харажатлари қиймати
                                </td>
                                <td class="text-center">
                                    {{autoDto.customsClearance}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.foreignCar">
                                <td class="text-center">
                                    Акциз солиқ қиймати
                                </td>
                                <td class="text-center">
                                    {{autoDto.excise}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.priceInCurrency">
                                <td class="text-center">
                                    Валютадаги суммаси
                                </td>
                                <td class="text-center">
                                    {{autoDto.priceInCurrency | currency('', 2, { thousandsSeparator: ' ' })}} {{autoDto.currency}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.priceInCurrency">
                                <td class="text-center">
                                    Валюта курси
                                </td>
                                <td class="text-center">
                                    {{autoDto.currencyRate | currency('', 2, { thousandsSeparator: ' ' })}} {{autoDto.currency}}
                                </td>
                            </tr>
                            <tr v-if="!autoDto.coincidental">
                                <td class="text-center">
                                    Машинанинг тикланиш қийматини суммаси
                                </td>
                                <td class="text-center">
                                    {{autoDto.govPrice | currency('', 2, { thousandsSeparator: ' ' })}} Сум
                                </td>
                            </tr>
                            <tr v-if="autoDto.coincidental">
                                <td class="text-center">
                                    Турдош машинанинг тикланиш қийматини суммаси
                                </td>
                                <td class="text-center">
                                    {{autoDto.coincidentalAutoDto.coincidentalPrice | currency('', 2, { thousandsSeparator: ' ' })}} Сум
                                </td>
                            </tr>
                            <tr v-if="autoDto.coincidental">
                                <td class="text-center">
                                    Қўшимча қиймат солиги
                                </td>
                                <td class="text-center">
                                    {{autoDto.coincidentalAutoDto.nds_tax | currency('', 2, { thousandsSeparator: ' ' })}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.coincidental">
                                <td class="text-center">
                                    Фойда солиги ставкаси
                                </td>
                                <td class="text-center">
                                    {{autoDto.coincidentalAutoDto.npr_tax | currency('', 2, { thousandsSeparator: ' ' })}}
                                </td>
                            </tr>
                            <tr v-if="autoDto.coincidental">
                                <td class="text-center">
                                    Махсулотнинг рентабиллик курсаткичи
                                </td>
                                <td class="text-center">
                                    {{autoDto.coincidentalAutoDto.profitabilityRatio | currency('', 2, { thousandsSeparator: ' ' })}}
                                </td>
                            </tr>
                            <tr>
                                <td class="text-center">
                                    Машинанинг эскириш қиймати
                                </td>
                                <td class="text-center">
                                    {{autoDto.dilapidationValue | currency('', 2, { thousandsSeparator: ' ' })}} %
                                </td>
                            </tr>

                            </tbody>
                        </table>
                      </div>

                    </div>
                    <h4 class="card-title text-center"><b>Автотранспортга ўрнатилган газ ускунаси</b></h4>
                    <div class="card">
                      <div class="table-wrapper">
                        <table class="table">
                            <thead>
                            <tr>
                                <th>Қурилма номи</th>
                                <th>Сиғими</th>
                                <th>Сони</th>
                                <th>Фойдаланилган веб-сайт</th>
                                <th>Бахоси (сўм)</th>
                                <th>Эскириш қиймати</th>
                                <th>Қиймати</th>
                            </tr>
                            </thead>
                            <tbody v-if="autoGasDevice">
                            <tr>
                                <td class="text-center">
                                    {{ autoGasDevice.name}}
                                </td>
                                <td>
                                    {{ autoGasDevice.capacity || '' }} л
                                </td>
                                <td>
                                    {{ autoGasDevice.qty || '' }} дона
                                </td>
                                <td class="text-center">
                                    {{ autoGasDevice.webSite}}
                                </td>
                                <td class="text-center">
                                    {{ autoGasDevice.price | currency('', 2, { thousandsSeparator: ' ' })}}
                                </td>
                                <td class="text-center">
                                    {{ autoGasDevice.dilapidationValue}} %
                                </td>
                                <td class="text-center">
                                    {{ autoGasDevice.totalPrice | currency('', 2, { thousandsSeparator: ' ' })}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="pull-right">
                        <h4 class="card-title">
                            <b>Xаражат ёндошув жами бахоси: <span class="text-success">{{autoDto.totalGovPrice | currency('', 0, { thousandsSeparator: ' ' })}} сўм</span></b>
                        </h4>
                    </div>
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="w-100 pt-3" style="border-top: 1px solid #CCCCCC">
            <button class="all-btn delete-btn float-right mr-2" @click="cancel">
                Бекор қилиш
            </button>
        </div>
    </b-modal>
</template>

<script>

    import bModal from 'bootstrap-vue/es/components/modal/modal'
    import bModalDirective from 'bootstrap-vue/es/directives/modal/modal'

    export default {
        name: "AutoEvaluationCalculation",
        components: {
            'b-modal': bModal
        },
        directives: {
            'b-modal': bModalDirective
        },
        data() {
            return {
                show: false,
                autoId: null,
                autoDto: {},
                autoGasDevice: null,
            }
        },
        methods: {
            init() {
                const vm = this;
                if (this.autoId != null) {
                    this.$http.get('auto/item/' + this.autoId).then(function (data) {
                        vm.autoDto = data.data;
                        vm.autoGasDevice = null;
                        if (vm.autoDto.autoPlusDeviceDtos.length > 0) {
                            vm.autoGasDevice = vm.autoDto.autoPlusDeviceDtos[0];
                        }
                    });
                }

            },
            cancel() {
                this.show = false;
            }
        },
        created() {
            this.$eventBus.$on('AutoEvaluationCalculation', (autoId) => {
                this.show = true;
                this.autoId = autoId;
                this.init();
            });
        }
    }
</script>

<style scoped>

</style>